import { Link } from '@remix-run/react';
import { PageRoutes } from '~/constants/routes';

export default function FirstOvernight({
  parentName,
  coparentName,
  firstOvernight,
}: {
  parentName: string | undefined;
  coparentName: string | undefined;
  firstOvernight: string | undefined;
}) {
  const parentClasses = 'bg-orange-light-20 border-orange';
  const coparentClasses = 'bg-blue-light-20 border-blue';

  return (
    <>
      <div className="flex items-center justify-between px-4 pt-4">
        <h5 className="text-sm font-medium text-brown">Parents</h5>
        <Link className="text-xs font-medium uppercase text-brown underline" to={PageRoutes.PARENT_INFO}>
          Edit
        </Link>
      </div>
      <div className="flex w-full items-center justify-between gap-x-4 px-4 pt-2">
        {[parentName, coparentName].map((parent, index) => (
          <div
            key={`${parent}-${index}`}
            className={`flex h-auto min-h-14 w-1/2 flex-col items-center justify-center rounded-lg border p-2 ${index ? coparentClasses : parentClasses}`}
          >
            {parent === firstOvernight ? (
              <span className="text-[8px] font-bold uppercase text-brown">
                1<span>st</span> Overnight
              </span>
            ) : null}
            <span className="block w-full break-words text-center text-base font-medium text-green-primary-text">
              {parent}
            </span>
          </div>
        ))}
      </div>
    </>
  );
}
